import Vue from "vue";
//模块功能：产品详情-特殊区域与事件信息查询
export default Vue.extend({
    name: "area-info",
    data: function () {
        return {
            contList: {
                list1: ["任意港口间里程", "气候航路", "分船型习惯航路", "分船型 / 季节习惯航路"],
                list2: ["航行警告与气象无线电警报区", "海盗高风险区与护航区", "搜救责任区", "ECAs 区", "载重线区", "时区、日升日落区等"],
                list3: ["航海通告", "航行警告", "海盗事件", "海难事故", "台风警告", "气象预警"]
            }
        };
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.specialarea');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/area-info.vue
// module id = null
// module chunks = 